import { CreateItemReviewForm, type CreateItemReviewFormProps } from '@/components/item-review/CreateItemReviewForm';

function ReviewPanel({ primaryKey, item }: { primaryKey: string; item?: CreateItemReviewFormProps['item'] }) {
    return (
        <div className="tw-w-full">
            <CreateItemReviewForm primaryKey={primaryKey} item={item} />
        </div>
    );
}

export default ReviewPanel;
